import React from 'react';
import './Footer.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Footer: React.FC = () => {
  const { ref: footerRef, style: footerStyle } = useScrollAnimation<HTMLElement>({ delay: 0.1 });
  const { ref: brandRef, style: brandStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.2 });
  const { ref: dividerRef, style: dividerStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.3 });
  const { ref: bottomRef, style: bottomStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.4 });

  return (
    <footer className="footer" ref={footerRef} style={footerStyle}>
      <div className="footer-container">
        <div className="footer-brand" ref={brandRef} style={brandStyle}>
          <span className="footer-logo">
            <span className="logo-main">Boost</span>
            <span className="logo-plus">+</span>
          </span>
          <p className="footer-tagline">Invest in the journey. Build together.</p>
        </div>

        <div className="footer-divider" ref={dividerRef} style={dividerStyle}></div>

        <div className="footer-bottom" ref={bottomRef} style={bottomStyle}>
          <p className="copyright">
            © 2024 Boost+ on SOL. All rights reserved.
          </p>
          <p className="disclaimer">
            Cryptocurrency investments carry risk. Always do your own research.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;